export default "__VITE_ASSET__ByJ$q$UN__"